export default __webpack_public_path__ + "static/media/bhuvanLogo_new1.158871e1.webp";